import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Info, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface ChlorineConfigHelpPanelProps {}

export function ChlorineConfigHelpPanel() {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Card className="mb-6">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="flex items-center gap-2">
          <Info className="h-5 w-5 text-blue-500" />
          <CardTitle className="text-lg">Chlorine System Configuration Help</CardTitle>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          className="h-8 w-8 p-0"
        >
          {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </Button>
      </CardHeader>
      {isExpanded && (
        <CardContent className="space-y-4 pt-0">
          <CardDescription className="text-sm">
            <strong>What is this?</strong> Chlorine system configuration tracks tank capacity and solution 
            concentration over time for accurate calculations in daily logs.
          </CardDescription>
          
          <div className="space-y-2 text-sm">
            <p><strong>Calculation Flow:</strong></p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Inches used × gallons per inch = gallons delivered</li>
              <li>Gallons delivered × lbs Cl₂ per gallon = total lbs Cl₂ used</li>
            </ul>
          </div>

          <div className="space-y-2 text-sm">
            <p><strong>Why date-based configs?</strong></p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Tank replacements (different capacity)</li>
              <li>Solution concentration changes</li>
              <li>Gauge recalibration</li>
              <li>Historical compliance (old logs use old configs)</li>
            </ul>
          </div>

          <div className="p-3 bg-muted/50 rounded-md text-xs">
            <strong>Key Behaviors:</strong>
            <ul className="list-disc pl-5 mt-1 space-y-0.5">
              <li>New active config (no activeTo) auto-closes previous config</li>
              <li>Overlap validation prevents conflicting date ranges</li>
              <li>Daily logs use config active on their log date</li>
              <li>Missing config = null calculations (no guessing)</li>
            </ul>
          </div>
        </CardContent>
      )}
    </Card>
  );
}
